import ffrToken from "@/image/ffrToken.png";
import usdrToken from "@/image/usdrToken.png";
import nfxToken from "@/image/nfxToken.png";
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const evmChain = [12306];
export const chainParams: any = {
  12306: {
    chainId: 12306,
    chainName: "Fibochain", // 自定义链的名称
    nativeCurrency: {
      name: "FIBO",
      symbol: "FIBO",
      decimals: 18,
    },
    rpcUrls: ["https://node1.fibo-rpc.asia/"],
    blockExplorerUrls: ["https://scan.fibochain.org/"],
  },
  56: {
    chainId: 56,
    chainName: "BSC",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    rpcUrls: ["https://bsc-dataseed.binance.org/"],
    blockExplorerUrls: ["https://bscscan.com"],
  },
  97: {
    chainId: 97,
    chainName: "BSC Testnet",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    rpcUrls: ["https://bsc-testnet-rpc.publicnode.com"],
    blockExplorerUrls: ["https://testnet.bscscan.com/"],
  },
};
export const tokenArr = [
  {
    symbol: "FFR",
    decimals: 18,
    address: "0x648712107a4ed92f8b150735a0b3836dfe9586a1", //正式
    logo: ffrToken,
  },
  {
    symbol: "USDR",
    decimals: 18,
    address: "0x41c973B7dEdE55708D3Ac539b2ac21Bae0a50254", //正式
    logo: usdrToken,
  },
  {
    symbol: "NFX",
    decimals: 18,
    address: "0x8ab13cef518432124ca9823264bdcf18b9c72a42",
    logo: nfxToken,
  },
];

export const swapAgreementCost = 0.3;
